/**
 * SCENARIOS-PROD-OFF-1.
 * `VITE_SCENARIOS_ENABLED` is inlined at build time by Vite. It is not read
 * at runtime. Missing, empty, or any value other than the string "true" is off.
 */
export function isScenariosUiEnabled(flag?: string | null): boolean {
  const value =
    flag === undefined
      ? (import.meta.env.VITE_SCENARIOS_ENABLED as string | undefined)
      : flag;
  return value === "true";
}
